<template>
    <div class="space-y-2">
        <draggable :list="rams[mode+'Risks']" draggable=".draggable" handle=".handle" @change="fieldsReordered"
                   class="space-y-2">
            <div v-for="(field, index) in rams[mode+'Risks']" :key="index" class="draggable p-2 rounded-lg"
                 :class="(rams.response && rams.response.perItemComments && rams.response.perItemComments[mode+'Risks'][index])?'bg-red-50':''">
                <div class="flex items-start mb-1">
                    <div class="w-6 flex-shrink-0 py-1.5" v-if="!rams.readonly && !readonly">
                        <i class="fa fa-bars text-sm text-gray-300 hover:text-gray-500 cursor-move handle"></i>
                    </div>
                    <input
                        placeholder="Hazard..."
                        class="bg-transparent flex-1 text-sm m-0 px-2 py-1 font-medium text-gray-700 border-transparent rounded shadow-none relative focus:z-10"
                        type="text"
                        ref="titles"
                        :disabled="readonly || rams.readonly"
                        v-model="field.hazard"
                        @input="saveIt()"
                        @keydown.enter.prevent="$emit('change', $event.target.value);$event.target.blur()"
                    >
                    <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
                        <ui-dropdown menu-class="p-3 w-56" v-if="!rams.readonly && !readonly">
                            <template #default="{ toggle }">
                                <button @click="toggle"
                                        class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h fa-fw"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-trash" danger @click="deleteField(index); close()">
                                    Delete
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
                <div class="flex items-start mb-1">
                    <div class="w-20 flex-shrink-0 text-right text-gray-400 text-xs pt-1">Risk:</div>
                    <ui-textarea
                        class="flex-1 px-2"
                        placeholder="Who/How..."
                        autoresize
                        rows="2"
                        field="resize-none"
                        name="content"
                        :disabled="readonly || rams.readonly"
                        v-model="field.hazardRisk"
                        @input="saveIt()"
                    ></ui-textarea>
                    <rams-risk-dropdown #default="{ open:open, close:close }"
                                        class="flex border border-gray-300 rounded px-2 py-1"
                                        :class="readonly || rams.readonly?'':'cursor-pointer hover:border-gray-400 hover:bg-gray-50 '"
                                        :item="field.harmWithoutControls"
                                        :rams="rams"
                                        :align-right="false"
                                        :readonly="readonly || rams.readonly"
                                        @apply="(e) => {}"
                                        trigger-class="w-[9.5rem]">
                        <div class="flex" @click="() => {if (!rams.readonly && !readonly) {open();}}">
                            <div class="flex-1">
                                <div class="text-xs text-gray-400">Without Controls</div>
                                <div class="text-xs text-gray-600 pl-1">
                                    <div>Likelihood: <span class="text-gray-600"
                                                           v-text="field.harmWithoutControls.likelihoodOfHarm?field.harmWithoutControls.likelihoodOfHarm:'?'"></span>
                                    </div>
                                    <div>Severity: <span class="text-gray-600"
                                                         v-text="field.harmWithoutControls.severityOfHarm?field.harmWithoutControls.severityOfHarm:'?'"></span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div
                                    class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                    v-text="field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm"
                                    :style="'background: '+getColor(field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm)">
                                </div>
                            </div>
                        </div>
                    </rams-risk-dropdown>
                </div>
                <div class="flex items-start mb-1">
                    <div class="w-20 flex-shrink-0 text-right text-gray-400 text-xs pt-1">Controls:</div>
                    <ui-textarea
                        class="flex-1 px-2"
                        placeholder="Controls..."
                        autoresize
                        rows="2"
                        field="resize-none"
                        name="content"
                        :disabled="readonly || rams.readonly"
                        v-model="field.controls"
                        @input="saveIt()"
                    ></ui-textarea>
                    <rams-risk-dropdown #default="{ open:open, close:close }"
                                        class="flex border border-gray-300 rounded px-2 py-1"
                                        :class="readonly || rams.readonly?'':'cursor-pointer hover:border-gray-400 hover:bg-gray-50 '"
                                        :item="field.harmWithControls"
                                        :rams="rams"
                                        :align-right="false"
                                        :readonly="readonly || rams.readonly"
                                        @apply="(e) => {}"
                                        trigger-class="w-[9.5rem]">
                        <div class="flex" @click="() => {if (!rams.readonly && !readonly) {open();}}">
                            <div class="flex-1">
                                <div class="text-xs text-gray-400">With Controls</div>
                                <div class="text-xs text-gray-600 pl-1">
                                    <div>Likelihood: <span class="text-gray-600"
                                                           v-text="field.harmWithControls.likelihoodOfHarm?field.harmWithControls.likelihoodOfHarm:'?'"></span>
                                    </div>
                                    <div>Severity: <span class="text-gray-600"
                                                         v-text="field.harmWithControls.severityOfHarm?field.harmWithControls.severityOfHarm:'?'"></span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div
                                    class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                    v-text="field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm"
                                    :style="'background: '+getColor(field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm)">
                                </div>
                            </div>
                        </div>
                    </rams-risk-dropdown>
                </div>
                <div class="p-2 text-red-500"
                     v-if="rams.response && rams.response.perItemComments && rams.response.perItemComments[mode+'Risks'][index]">
                    <div class="flex">
                        <label>Rejection comments:</label>
                    </div>
                    <div
                        class="bg-white whitespace-pre-wrap m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 placeholder-gray-400"
                        v-text="rams.response.perItemComments[mode+'Risks'][index]"></div>
                </div>
            </div>
        </draggable>

        <!-- New Item. -->
        <div class="relative" v-if="!rams.readonly && !readonly">
            <input
                placeholder="Add New Hazard..."
                class="text-sm m-0 pl-8 pr-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative"
                type="text"
                v-model="newFieldTitle"
                @input="addField"
            >
            <div class="absolute left-0 inset-y-0 w-8 flex items-center justify-center">
                <i class="fa fa-plus text-sm text-gray-400"></i>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {RAMS} from "@models";
import UiTextarea from "../../ui/UiTextarea.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import EstimateTaskItemLabourCalcDropdown
    from "../../estimation/estimates/build/EstimateTaskItemLabourCalcDropdown.vue";
import RamsRiskDropdown from "./RamsRiskDropdown.vue";
import {debounce} from "lodash";

export default {
    components: {
        RamsRiskDropdown,
        EstimateTaskItemLabourCalcDropdown,
        UiDropdownItem,
        UiDropdown,
        UiTextarea,
        draggable,
    },
    props: {
        rams: RAMS,
        readonly: false,
        mode: String,
    },
    data() {
        return {
            newFieldTitle: '',
            saveIt: debounce(this.save, 400, {leading: true, maxWait: 3000}),
        }
    },
    methods: {
        save() {
            this.rams.save();
        },
        getColor(num) {
            return RAMS.getColor(num);
        },
        addField() {
            this.rams[this.mode + 'Risks'].push({
                hazard: this.newFieldTitle,
                hazardRisk: '',
                controls: '',
                harmWithControls: {},
                harmWithoutControls: {},
            })
            this.$nextTick(async () => {
                const input = this.$refs.titles[this.$refs.titles.length - 1]
                input.focus()
                this.newFieldTitle = ''
                await this.rams.update()
            })
        },
        deleteField(index) {
            this.rams[this.mode + 'Risks'].splice(index, 1)
            this.rams.update()
        },
        fieldsReordered() {
            this.rams.update()
        },
    },
}
</script>
